// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w982","content":"styles_content__2xhsk"};